import React from 'react';
import { Link } from 'react-router-dom';
import { SupportLayout } from './SupportLayout';

export const CancellationPage: React.FC = () => {
  return (
    <SupportLayout
      title="Cancellation options"
      subtitle="What happens to your money when plans change. Each listing picks one of three policies."
    >
      <div className="space-y-6">
        <div className="border-l-4 border-green-500 pl-5 py-2">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Flexible</h2>
          <p className="text-gray-700">
            Cancel up to 24 hours before check-in for a full refund. Anything later, you keep the first night and
            get the rest back.
          </p>
        </div>

        <div className="border-l-4 border-amber-500 pl-5 py-2">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Moderate</h2>
          <p className="text-gray-700">
            Cancel up to 5 days before check-in for a full refund. Between 5 days and check-in, you get half back.
            After check-in, the nights you've already spent are non-refundable; remaining nights get 50% back.
          </p>
        </div>

        <div className="border-l-4 border-red-500 pl-5 py-2">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Strict</h2>
          <p className="text-gray-700">
            Cancel within 48 hours of booking AND at least 14 days before check-in for a full refund. Inside that
            window, you get 50% back up to 7 days before check-in. After that, no refund.
          </p>
        </div>
      </div>

      <h2 className="text-2xl font-semibold text-gray-900 mt-12 mb-3">When you always get refunded</h2>
      <ul className="space-y-3 text-gray-700">
        <li>
          <strong className="text-gray-900">The host cancels.</strong> Full refund, every time. We'll also help you
          find a comparable place.
        </li>
        <li>
          <strong className="text-gray-900">The place doesn't match the listing.</strong> Wrong number of bedrooms,
          missing amenities advertised as included, photos misleading. Report within 24 hours of check-in.
        </li>
        <li>
          <strong className="text-gray-900">The place is unsafe or unsanitary.</strong> Document it, contact us
          within 24 hours of check-in.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-3">How to cancel</h2>
      <ol className="space-y-3 text-gray-700 list-decimal pl-5">
        <li>
          Open your booking from{' '}
          <Link to="/dashboard/bookings" className="text-primary-600 underline">
            My bookings
          </Link>
          .
        </li>
        <li>Hit Cancel and pick a reason.</li>
        <li>
          Refund processing: card refunds land in 5-10 business days, Whish refunds usually same day.
        </li>
      </ol>

      <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-3">Service fees</h2>
      <p className="text-gray-700">
        Stripe processing fees on refunds are non-recoverable; we absorb them. The platform service fee is refunded
        in full whenever the nightly amount is.
      </p>

      <div className="mt-12 p-6 bg-gray-50 rounded-2xl">
        <p className="text-gray-900 font-medium mb-2">Edge case?</p>
        <p className="text-gray-600 mb-4">
          Trip cancelled because of a flight, illness, or something out of your control? Email us. We look at every
          one of these manually.
        </p>
        <Link
          to="/contact"
          className="inline-block px-6 py-3 bg-primary-500 text-white font-semibold rounded-xl hover:bg-primary-600 transition-colors"
        >
          Talk to us
        </Link>
      </div>
    </SupportLayout>
  );
};

export default CancellationPage;
